import { del, get, post, put } from '../../client';
import { shouldLogApiCalls } from '../../config';

export const listTags = async (page_at, page_size, sort_by, sort_order, search_term) => {
    if (shouldLogApiCalls) {
        console.log('List tags attempt:', { page_at, page_size, sort_by, sort_order, search_term });
    }
    
    const searchParam = search_term ? `&search_term=${encodeURIComponent(search_term)}` : '';
    const sortParam = sort_by && sort_order ? `&sort_by=${encodeURIComponent(sort_by)}&sort_order=${encodeURIComponent(sort_order)}` : '';
    const url = `/tag?page_at=${page_at}&page_size=${page_size}${sortParam}${searchParam}`;
    return get(url);
}

export const createTag = async (name, color) => {
    return post(`/tag`, { name, color });
}

export const updateTag = async (id, name, color) => {
    return put(`/tag/${id}`, { name, color });
}

export const deleteTag = async (id) => {
    return del(`/tag/${id}`);
}

export const getTag = async (id, page, pageSize) => {
    return get(`/tag?tag_id=${id}&page_at=${page}&page_size=${pageSize}`);
}

export const bulkRemoveContactFromTag = async (tagId, contactIds) => {
    return post(`/contact/tag/${tagId}`, { contacts: contactIds, is_deletion: true });
}

export const bulkAddContactToTag = async (tagId, contactIds) => {
    return post(`/contact/tag/${tagId}`, { contacts: contactIds, is_deletion: false });
}

export const bulkAddAllContactsToTag = async (tagId, filters) => {
    return post(`/contact/tag/${tagId}`, { all_contacts: true, filters: filters, is_deletion: false });
}

